export const NAVBAR_HEIGHT = 69;
export const PAGE_HEIGHT = `calc(100vh - ${NAVBAR_HEIGHT}px)`;
